
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard-selection",
      function () {
        return require("private-next-pages/dashboard-selection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard-selection"])
      });
    }
  